'use client';

import { useState } from 'react';
import { Mail, Phone, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [honeypotValue, setHoneypotValue] = useState('');

  const handleRevealContact = (e: React.FormEvent) => {
    e.preventDefault();
    if (honeypotValue) {
      console.log('Bot detected');
      return;
    }
    setShowContact(true);
  };

  return (
    <footer className="bg-background border-t border-[hsl(var(--border))]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Footer content - always visible */}
        <div className="py-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Contact Section */}
            <div className="md:col-span-2">
              <div className="space-y-4">
                <div className="inline-flex items-center justify-center w-10 h-10 bg-accent/15 rounded-full text-primary">
                  <HelpCircle className="w-5 h-5" />
                </div>

                <h3 className="text-xl font-bold text-foreground">Have questions?</h3>

                <p className="text-muted-foreground">
                  We're here to assist you with any questions about buying or selling lead lists.
                </p>

                {!showContact ? (
                  <form onSubmit={handleRevealContact}>
                    <div className="opacity-0 absolute -z-10 left-[-9999px]">
                      <label htmlFor="website">Website</label>
                      <input
                        type="text"
                        id="website"
                        name="website"
                        value={honeypotValue}
                        onChange={(e) => setHoneypotValue(e.target.value)}
                        tabIndex={-1}
                        autoComplete="off"
                      />
                    </div>

                    <Button
                      type="submit"
                      className="gradient-bg hover:opacity-90 transition-opacity"
                    >
                      Show Contact Information
                    </Button>
                  </form>
                ) : (
                  <div className="space-y-3 animate-scale-in">
                    <a
                      href="mailto:toni@getlists.io"
                      className="inline-flex items-center gap-2 text-primary hover:bg-primary/10 px-3 py-1.5 rounded-lg transition-colors"
                    >
                      <Mail className="w-4 h-4" />
                      toni@getlists.io
                    </a>
                    <div className="h-px w-12 bg-[hsl(var(--border))]"></div>
                    <a
                      href="https://wa.me/491724096125"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary hover:bg-primary/10 px-3 py-1.5 rounded-lg transition-colors"
                    >
                      <Phone className="w-4 h-4" />
                      WhatsApp: +49 172 409 6125
                    </a>
                  </div>
                )}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-sm font-semibold uppercase text-muted-foreground mb-4">
                Marketplace
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    href="/lists"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Browse Lead Lists
                  </Link>
                </li>
                <li>
                  <Link
                    href="/scrapers"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Browse Scrapers
                  </Link>
                </li>
                <li>
                  <Link
                    href="/group-buys"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Browse Group Buys
                  </Link>
                </li>
                {/* <li>
                  <Link
                    href="/services"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Our Services
                  </Link>
                </li> */}
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h3 className="text-sm font-semibold uppercase text-muted-foreground mb-4">
                Resources
              </h3>
              <ul className="space-y-2">
                {/* <li>
                  <Link
                    href="/sell"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Sell / Offer
                  </Link>
                </li> */}
                <li>
                  <Link
                    href="/blog"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    href="/dashboard"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Dashboard
                  </Link>
                </li>
                {/* <li>
                  <Link
                    href="/about"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    href="/terms"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    href="/privacy"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright - Always visible */}
        <div className="py-4 text-center text-sm text-muted-foreground border-t border-[hsl(var(--border))]">
          <p> 2025 GetLists. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
